import { Outlet } from 'react-router-dom'

import EmployeesComponent from 'modules/locations/pages/Locations/Employees'

const AuthorizedEmployeesPage = () => {
  return (
    <EmployeesComponent>
      <Outlet />
    </EmployeesComponent>
  )
}

export default AuthorizedEmployeesPage
